module.exports = __webpack_public_path__ + "static/assets/6cdce0f6f0187f0e481ecd64bf207db1.svg";